import { Icon } from '@chakra-ui/react';
import React from 'react';

const Settings = props => {
  return (
    <Icon
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.99995 7.76663C10.9916 7.76663 11.8 6.95829 11.8 5.96663C11.8 4.97496 10.9916 4.16663 9.99995 4.16663C9.00828 4.16663 8.19995 4.97496 8.19995 5.96663C8.19995 6.95829 9.00828 7.76663 9.99995 7.76663Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.65815 15.8333C6.64982 15.8333 7.45815 15.0249 7.45815 14.0333C7.45815 13.0416 6.64982 12.2333 5.65815 12.2333C4.66649 12.2333 3.85815 13.0416 3.85815 14.0333C3.85815 15.0249 4.65815 15.8333 5.65815 15.8333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.3415 15.8333C15.3332 15.8333 16.1415 15.0249 16.1415 14.0333C16.1415 13.0416 15.3332 12.2333 14.3415 12.2333C13.3498 12.2333 12.5415 13.0416 12.5415 14.0333C12.5415 15.0249 13.3498 15.8333 14.3415 15.8333Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
};

export default Settings;
